<template>

<v-dialog v-model="dialog" width="90vw">
  <v-card>
    <p class=".title ma-2">Ledger mutations - Agent: {{hagrHagm.eign_code}} {{hagrHagm.eign_naam}}</p>
    <v-form ref="showHagrHagm">
       <v-simple-table dense>
        <template v-slot:default>
          <thead>
              <tr>
                <td><span class="10px font-weight-light">Date / Time</span></td>
                <td><span class="10px font-weight-light">Description</span></td>
                <td align="right"><span class="10px font-weight-light">Deb</span></td>
                <td align="right"><span class="10px font-weight-light">Cred</span></td>
                <td align="right"><span class="10px font-weight-light">Amount</span></td>
                <td align="right"><span class="10px font-weight-light">Payment</span></td>
              </tr>  
            </thead>
            <tbody v-for="(hagrRecord,k1) in hagrHagm.hagr" :key="k1">
              <tr>
                <td> {{hagrRecord.hagr_dt}} </td>
                <td>{{hagrRecord.fctitaal_oms}}</td>
                <td></td>
                <td></td>
                <td align="right">{{hagrRecord.hagr_line }}</td>
                <td align="right">{{hagrRecord.hagr_payment }}</td>
              </tr>
              <tr v-for="(hagmRecord,k2) in hagrRecord.hagm" :key="k2">
                <td><span class="mx-2">{{hagmRecord.hagm_datum}}</span></td>
                <td><span class="mx-3">{{hagmRecord.gbrk_nr}} - {{hagmRecord.gbrk_oms}}</span></td>
                <td align="right">{{hagmRecord.hagm_deb}}</td>
                <td align="right">{{hagmRecord.hagm_cred}}</td>
              </tr>  
            </tbody>  
        </template>  
      </v-simple-table>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      hagrHagm: {}
    }
  },
  methods: {
    open(huov_encrid, hagm_boek_verblijf) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.$axios
        .post("ares/json/ares/huov/hagr/hagm/getHagrHagm.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHagrHagm"
          },
          getHagrHagm: {
            huov_encrid: huov_encrid,
            hagm_boek_verblijf: hagm_boek_verblijf
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hagrHagm = res.data.getHagrHagm;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

